<div class="mobile-pivot hide-acc">
  <ul>
    <li *ngFor='let item of pivot'><a href="javascript:void(0)" routerLink='{{item.routerLink}}'> {{item.label}} </a></li>
</ul>
</div>
